import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';

declare var fbq;
declare var gtag;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  path: any = "";
  fechasDisclaimer: any = {};
  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) { 
    this.path = this.route.routeConfig.path;

    this.api.getFechasDisclaimer().subscribe(response => {
      this.fechasDisclaimer.fechaInicio = new Date(response.data.fecha_inicio);
      this.fechasDisclaimer.fechaFin = new Date(response.data.fecha_fin);
    });

  }

  ngOnInit() {
    
  }

  trackEvent(gAction = null, gCategory = "", gLabel = "", FbEvent = null) {
    if (gAction) {
      gtag('event', gAction, {
        'event_category': gCategory,
        'event_label': gLabel
      });
    }

    if (FbEvent) {
      fbq('track', FbEvent);
    }
  }

}
